module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-2-lowlands"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "groningen-the-netherlands-19301949"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("for survivors and then barricaded, it was time for celebration. The Black Watch and Calgary Highlanders, who had liberated much of the city, held a victory parade. I had seen pictures of Scotchmen in kilts but had never seen any. Now, I saw Canadians in Highland gear; all very confusing. They marched to the tune of pipers who were playing Great Highland bagpipes. The pipers were in traditional Scottish pipers’ outfits, complete with feather bonnets, doublets and plaids, although one also had the skin of a tiger thrown over his shoulders. They had impressive sporrans that danced with their kilts as they marched; their feet were covered in spats and brogues. I vaguely wondered if they kept all these things in their tanks. Long after the parade had finished, I heard the strange, haunting vibrations of the bagpipes in my head – they just did not go away.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Arthur and his blond wife stayed with us until the summer. When it became possible to travel again, they left for France. A time of hardship followed. After a difficult autumn, people had to endure yet another awfully cold winter. The treasury and all banks had been robbed by the occupiers and the nation was bankrupt. Our meagre rations were even further reduced. Added to this came the fear of a new occupation, this time by the Russians; anxiety undermined the certainty of the new freedom. Yet, gradually, life started to resume a semblance of normality. Jan and his family had survived the ordeal, and were allocated temporary accommodation. On my bike I was able to visit the cottage where Toni van der Laan, Kusha, and her brother were staying. As they had no bicycles, I brought things from the city for Kusha’s mother, including brushes and soap for the cleaning of their home in Groningen, which had been allocated to Nazi sympathisers by the secret police. The house was a filthy mess. It was also depleted, and all that had been considered of value had been taken. There was a lot to do but at long last Toni and her children were able to go home.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("As May drew to a close, Eric van der Laan came home. He arrived in the middle of the night, looking a wreck. He was alive but only just, Kusha’s brother Wicky did not even recognise him. Incredibly, he was one of the very few who had survived the bombardment of the prisoner ships in the Bay of Lübeck. Afterwards, he had been plucked from the rim of death, and was taken to a makeshift British military field hospital. There, he was nursed back until he had improved enough to be able to undertake the journey home. In the post-war chaos, this had taken days but he got there.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("He wrote a brief report on what had happened to him and thereafter never spoke of it except once, when he told me how he had escaped the sinking ship by clambering out of a porthole and onto the hull. I heard him then but without listening – I was tired of war stories and wanted to think about the future. I was young and foolish. Eric van der Laan stopped his account when he noticed that I was not taking it in. He looked at me, and I became aware that he knew that I would never be able to understand.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b053db5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0040.vue
// module id = 180
// module chunks = 0